"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = require("lodash");

var _constants = _interopRequireDefault(require("./constants"));

/* eslint-disable lodash/import-scope */
var Utils = function Utils() {
  (0, _classCallCheck2["default"])(this, Utils);
};

(0, _defineProperty2["default"])(Utils, "doesPropertyExist", function (object, propertyPath) {
  return (0, _lodash.has)(object, propertyPath);
});
(0, _defineProperty2["default"])(Utils, "setEventProperty", function (eventObject, propertyPath, propertyValueObject) {
  (0, _lodash.set)(eventObject, propertyPath, propertyValueObject);
});
(0, _defineProperty2["default"])(Utils, "setEventCategory", function (eventObject, primaryCategoryName) {
  var category = {
    primaryCategory: primaryCategoryName
  };
  (0, _lodash.set)(eventObject, _constants["default"].PropertyPaths.Category, category);
});
(0, _defineProperty2["default"])(Utils, "setEventEventInfo", function (eventObject, eventName) {
  var eventInfo = {
    eventName: eventName
  };
  (0, _lodash.set)(eventObject, _constants["default"].PropertyPaths.EventInfo, eventInfo);
});
(0, _defineProperty2["default"])(Utils, "setUserProfileAuthenticationStatus", function (authenticationStatus) {
  window.digitalData.user = window.digitalData.user || {};
  window.digitalData.user.profile = window.digitalData.user.profile || {};
  window.digitalData.user.profile.authenticationStatus = authenticationStatus;
});
var _default = Utils;
exports["default"] = _default;
//# sourceMappingURL=Utils.js.map